module.exports = __webpack_public_path__ + "img/2.d9d737d5.png";